import { render, staticRenderFns } from "./communityMain.vue?vue&type=template&id=1bc20a0b&scoped=true"
import script from "./communityMain.vue?vue&type=script&lang=js"
export * from "./communityMain.vue?vue&type=script&lang=js"
import style0 from "./communityMain.vue?vue&type=style&index=0&id=1bc20a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc20a0b",
  null
  
)

export default component.exports